require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = ./node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module chunks = 0